import { PersonalInfo, AboutInfo, HeroStats, ContactInfo } from '../types';

export const personalInfo: PersonalInfo = {
  name: 'Jeremiah',
  title: 'Backend Engineer',
  subtitle: 'Passionate about building scalable backend systems and exploring innovative technologies. Currently diving deep into AI and machine learning while crafting robust APIs and microservices.',
  location: 'Kochi, Kerala, India',
  email: 'jeremiahthaiparambil@gmail.com',
  github: 'https://github.com/jeremiahmanuel',
  linkedin: 'https://www.linkedin.com/in/jeremiah-manuel-49176014a/',
};

export const aboutInfo: AboutInfo = {
  education: 'B.Tech in Computer Science Engineering',
  role: 'Senior Software Engineer',
  specializations: [
    'Backend architecture and system design',
    'RESTful API development and optimization', 
    'Database design and performance tuning',
    'Microservices patterns and distributed systems'
  ],
  personalContent: 'Outside of work, I\'m usually reading fiction or catching up on manhwa. I\'m a big anime and movie fan too. When I need to clear my head, I listen to music or go for walks.',
};

export const heroStats: HeroStats = {
  experience: '4+',
  projectsCompleted: '10+',
  technologies: '15+',
  coffeeConsumed: '∞',
};

export const contactInfo: ContactInfo = {
  email: 'jeremiahthaiparambil@gmail.com',
  location: 'Kochi, Kerala, India',
  role: 'Senior Software Engineer',
  availability: 'Open to new opportunities and collaborations',
}; 